import { useFetch } from 'use-http'
import { getAbsoluteServerUrl } from '../config/config'

export type OverviewBlock = {
    id: number;
    title: string;
    position: number;
    html: string;
}

/**
 * Bloques de la seccion "De un vistazo" (/transicion). Antes vivian hardcodeados
 * en esta pagina; ahora se editan desde el backoffice.
 */
export function useGetOverviews() {
    return useFetch<OverviewBlock[]>(getAbsoluteServerUrl('/overviews'), { responseType: 'json' }, [])
}
